// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';
// Define a service using a base URL and expected endpoints
const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL_admin}/matchstatement`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');

    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const matchStatementApi = createApi({
  reducerPath: 'matchStatementApi',
  baseQuery,
  endpoints: (builder) => ({
    getGroupBankAcc: builder.query({
      query: () => '/group-bank-acc',
    }),
    getCaseLog: builder.query({
      query: (q = {}) => {
        const params = [
          q.page ? `page=${q.page}` : '',
          q.limit ? `limit=${q.limit}` : '',
          q.search ? `search=${encodeURIComponent(q.search)}` : '',
          q.sortBy ? `sortBy=${q.sortBy}` : '',
          q.sortOrder ? `sortOrder=${q.sortOrder}` : '',
        ]
          .filter(Boolean)
          .join('&');

        return `/caseLog${params ? `?${params}` : ''}`;
      },
      transformResponse: (response, _, arg) => ({ ...response, query: arg }),
    }),
    deleteStatement: builder.mutation({
      query: (body = {}) => {
        const statementRef = Array.isArray(body.statementRef)
          ? body.statementRef.join(',')
          : body.statementRef || '';

        return {
          url: `/deleteStatement?statementRef=${encodeURIComponent(statementRef)}`,
          method: 'DELETE',
        };
      },
    }),
    restoreStatement: builder.mutation({
      query: (body = {}) => ({
        url: '/restoreStatement',
        method: 'POST',
        body,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetGroupBankAccQuery,
  useGetCaseLogQuery,
  useDeleteStatementMutation,
  useRestoreStatementMutation,
} = matchStatementApi;
